import Vue from 'vue';

/**
 * This file enables the automatic initialization
 * of module Javascript based on the prevalence of
 * data-module="" attributes in the DOM. You should not
 * really need to interact with this file. It is
 * included once in main.js only.
 */
class Init {
  constructor() {
    this.modules = [];
    this.init = this.init.bind(this);
  }

  async loadModule(name, sections) {
    const m = await import(
      /* webpackChunkName: "[index]" */ `../../../modules/${name}/${name}.js`
    );
    const module = m.default;
    const moduleElements = [...sections].filter(
      (section) => section.dataset.module === name
    );

    moduleElements.forEach((element) => {
      if (module) {
        module(element);
      }
    });
  }

  async init() {
    const uniq = (value, index, self) => self.indexOf(value) === index;
    const sections = document.querySelectorAll('[data-module]');
    const sectionNames = [...sections]
      .map((section) => section.dataset.module)
      .filter(uniq);

    const vueBaseComponents = document.querySelectorAll('[base-component]');
    const vueBaseComponentNames = [...vueBaseComponents]
      .map((section) => section.getAttribute('base-component'))
      .filter(uniq);

    // Initialize priority modules first
    const prioritySections = document.querySelectorAll('[data-module][data-priority]');
    const prioritySectionNames = [...prioritySections]
      .map((section) => section.dataset.module)
      .filter(uniq);

    // Load priority modules first
    for (const name of prioritySectionNames) {
      await this.loadModule(name, prioritySections);
    }

    // Initialize remaining modules that use data-module="module-name" syntax
    const remainingSectionNames = sectionNames.filter(name => !prioritySectionNames.includes(name));
    for (const name of remainingSectionNames) {
      await this.loadModule(name, sections);
    }

    // Initialize Vue components that use base-component="component-name" syntax
    // This registers the Vue component globally
    // Only commonly reused components should be registered this way
    for (const name of vueBaseComponentNames) {
      const m = await import(
        /* webpackChunkName: "[index]" */ `../../../modules/${name}/${name}.vue.js`
      );
      Vue.component(name, m.default || m);
    }
  }
}

export default new Init();
